// src/components/ThemeToggle.js
import { useTheme } from "../context/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ compact = false }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: compact ? "0" : "6px",
        padding: compact ? "6px" : "6px 12px",
        borderRadius: "999px",
        border: "1px solid var(--border-medium)",
        background: isDark ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.05)",
        color: "var(--text-accent)",
        cursor: "pointer",
        transition: "all 0.25s ease",
        fontSize: "0.8rem",
        fontWeight: 600,
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = isDark
          ? "rgba(251,191,36,0.15)"
          : "rgba(21,128,61,0.10)";
        e.currentTarget.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = isDark
          ? "rgba(255,255,255,0.07)"
          : "rgba(0,0,0,0.05)";
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      {/* Animated icon swap */}
      <span
        style={{
          display: "flex",
          alignItems: "center",
          transition: "transform 0.4s ease",
          transform: isDark ? "rotate(0deg)" : "rotate(180deg)",
        }}
      >
        {isDark ? <Moon size={15} /> : <Sun size={15} />}
      </span>

      {!compact && (
        <span>{isDark ? "Dark" : "Light"}</span>
      )}

      {/* Track / pill indicator */}
      {!compact && (
        <span
          style={{
            display: "inline-flex",
            width: "28px",
            height: "15px",
            borderRadius: "999px",
            background: isDark ? "rgba(255,255,255,0.15)" : "rgba(21,128,61,0.18)",
            border: "1px solid var(--border-medium)",
            position: "relative",
            marginLeft: "2px",
            transition: "background 0.3s",
          }}
        >
          <span
            style={{
              position: "absolute",
              top: "2px",
              left: isDark ? "2px" : "13px",
              width: "9px",
              height: "9px",
              borderRadius: "50%",
              background: "var(--text-accent)",
              transition: "left 0.3s ease",
              boxShadow: "0 0 4px rgba(0,0,0,0.3)",
            }}
          />
        </span>
      )}
    </button>
  );
}
